import template from './sw-cms-block-text-three-column.html.twig';
import './sw-cms-block-text-three-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
